import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

const H2 = "font-display text-lg font-semibold text-[#1A1A1A]";
const P = "mt-3";
const LINK = "text-[#E11D2A] underline-offset-4 transition-colors hover:text-[#F02837] hover:underline";

export default function Datenschutz() {
  return (
    <>
      <Seo
        title="Datenschutzerklärung | Sportwetten NRW GmbH"
        description="Datenschutzerklärung der Sportwetten NRW GmbH: Verantwortliche Stelle, Datensparsamkeit, Consent für externe Medien (Google Maps) und deine Rechte."
        path="/datenschutz"
      />
      <section className="bg-[#FAFAFA]" data-testid="datenschutz-page">
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-12 lg:py-24">
          <Reveal>
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-[#1A1A1A] sm:text-4xl">Datenschutzerklärung</h1>

            <div className="mt-8 space-y-8 text-sm leading-relaxed text-[#52525B]">
              <div>
                <h2 className={H2}>1. Verantwortliche Stelle</h2>
                <address className={`${P} not-italic`}>
                  Sportwetten NRW GmbH
                  <br />
                  Westerwieher Straße 1 · 33397 Rietberg
                  <br />
                  E-Mail:{" "}
                  <a href="mailto:sportwettennrw@gmail.com" className={LINK} data-testid="datenschutz-email-link">
                    sportwettennrw@gmail.com
                  </a>
                </address>
                <p className={P}>
                  Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
                  gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung personenbezogener
                  Daten entscheidet.
                </p>
              </div>

              <div>
                <h2 className={H2}>2. Datenschutzbeauftragter</h2>
                <p className={P}>Wir haben einen externen Datenschutzbeauftragten bestellt:</p>
                <address className={`${P} not-italic`} data-testid="datenschutz-dsb">
                  Kerberos Compliance-Managementsysteme GmbH
                  <br />
                  z. Hd. Datenschutzbeauftragter
                  <br />
                  Im Zollhafen 24 · 50678 Köln
                  <br />
                  E-Mail:{" "}
                  <a href="mailto:dsb@kerberos-cms.com" className={LINK} data-testid="datenschutz-dsb-email">
                    dsb@kerberos-cms.com
                  </a>
                </address>
              </div>

              <div>
                <h2 className={H2}>3. Grundsatz: Datensparsamkeit</h2>
                <p className={P}>
                  Diese Website kommt ohne Tracking-Cookies, ohne Analyse-Tools und ohne Kontaktformular
                  aus. Es werden keine personenbezogenen Profile erstellt. Deine Einwilligungsauswahl
                  wird ausschließlich lokal in deinem Browser gespeichert (localStorage) und nicht an
                  uns übertragen.
                </p>
              </div>

              <div>
                <h2 className={H2}>4. Hosting und Server-Logdateien</h2>
                <p className={P}>
                  Diese Website wird auf Servern eines Hosting-Dienstleisters betrieben. Beim Aufruf
                  der Seiten verarbeitet der Dienstleister automatisch technische Zugriffsdaten
                  (sog. Server-Logfiles): Browsertyp und -version, Betriebssystem, Referrer-URL,
                  Uhrzeit der Anfrage und IP-Adresse. Eine Zusammenführung dieser Daten mit anderen
                  Datenquellen findet nicht statt. Die Verarbeitung erfolgt auf Grundlage von
                  Art. 6 Abs. 1 lit. f DSGVO; unser berechtigtes Interesse ist der sichere und
                  zuverlässige Betrieb dieser Website.
                </p>
              </div>

              <div>
                <h2 className={H2}>5. Standortabfrage (Geolocation)</h2>
                <p className={P}>
                  Die Funktion „Meinen Standort verwenden“ im Standortfinder fragt deinen Gerätestandort
                  nur ab, wenn du die Schaltfläche aktiv anklickst. Die Koordinaten werden ausschließlich
                  in deinem Browser zur Entfernungsberechnung genutzt und nicht gespeichert oder übertragen.
                </p>
              </div>

              <div>
                <h2 className={H2}>6. Google Maps (externe Inhalte)</h2>
                <p className={P}>
                  Karten von Google Maps (Anbieter: Google Ireland Ltd., Gordon House, Barrow Street,
                  Dublin 4, Irland) werden erst geladen, nachdem du ausdrücklich zugestimmt hast
                  („Google Maps laden“ bzw. „Erlauben“ im Hinweisbanner). Erst beim Laden der Karte
                  werden Daten (u.&nbsp;a. deine IP-Adresse) an Google übertragen; ohne deine Zustimmung
                  findet keine Verbindung zu Google statt. Rechtsgrundlage ist deine Einwilligung gemäß
                  Art. 6 Abs. 1 lit. a DSGVO i.&nbsp;V.&nbsp;m. § 25 Abs. 1 TDDDG. Die Zustimmung kannst
                  du jederzeit über „Cookie-Einstellungen“ im Footer widerrufen.
                </p>
              </div>

              <div>
                <h2 className={H2}>7. Hinweis zur Datenübertragung in Drittstaaten</h2>
                <p className={P}>
                  Bei der Nutzung von Google Maps können personenbezogene Daten (insbesondere deine
                  IP-Adresse) an Google-Server außerhalb der EU übertragen werden, darunter in die USA.
                  In diesen Ländern kann kein mit der EU vergleichbares Datenschutzniveau garantiert
                  werden. Die Übertragung erfolgt erst nach deiner ausdrücklichen Einwilligung.
                </p>
              </div>

              <div>
                <h2 className={H2}>8. Kontaktaufnahme</h2>
                <p className={P}>
                  Bei Kontaktaufnahme per E-Mail verarbeiten wir deine Angaben zur Bearbeitung der
                  Anfrage (Art. 6 Abs. 1 lit. b DSGVO bei Vertragsbezug, im Übrigen Art. 6 Abs. 1
                  lit. f DSGVO). Ein Kontaktformular wird auf dieser Website nicht betrieben; es werden
                  keine Anfragen in einer Datenbank gespeichert. Die Daten verbleiben bei uns, bis du
                  uns zur Löschung aufforderst oder der Zweck der Speicherung entfällt; gesetzliche
                  Aufbewahrungsfristen bleiben unberührt.
                </p>
              </div>

              <div>
                <h2 className={H2}>9. Speicherdauer</h2>
                <p className={P}>
                  Soweit in dieser Erklärung keine speziellere Speicherdauer genannt ist, verbleiben
                  personenbezogene Daten bei uns, bis der Zweck der Verarbeitung entfällt. Wenn du ein
                  berechtigtes Löschersuchen geltend machst oder eine Einwilligung widerrufst, werden
                  deine Daten gelöscht, sofern keine rechtlich zulässigen Gründe für eine weitere
                  Speicherung bestehen.
                </p>
              </div>

              <div>
                <h2 className={H2}>10. Widerruf deiner Einwilligung</h2>
                <p className={P}>
                  Du kannst eine bereits erteilte Einwilligung jederzeit mit Wirkung für die Zukunft
                  widerrufen – für externe Medien über „Cookie-Einstellungen“ im Footer. Die
                  Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt unberührt.
                </p>
              </div>

              <div>
                <h2 className={H2}>11. KI-generierte Inhalte</h2>
                <p className={P}>
                  Einzelne Bilder und Texte auf dieser Website wurden mit Werkzeugen künstlicher
                  Intelligenz erstellt und dienen der Illustration (z.&nbsp;B. Atmosphäre- und
                  Quoten-Darstellungen). Sie zeigen keine realen Personen und keine realen
                  Wettquoten; tatsächliche Quoten erfährst du in unseren Filialen. Durch die Erstellung
                  und Darstellung dieser Inhalte werden keine personenbezogenen Daten von Besuchern
                  verarbeitet.
                </p>
              </div>

              <div>
                <h2 className={H2}>12. Deine Rechte</h2>
                <p className={P}>
                  Du hast im Rahmen der gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche
                  Auskunft über deine gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger
                  sowie den Zweck der Verarbeitung, ferner Rechte auf Berichtigung, Löschung,
                  Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch.
                </p>
                <p className={P}>
                  Im Falle datenschutzrechtlicher Verstöße steht dir ein Beschwerderecht bei der
                  zuständigen Aufsichtsbehörde zu. Zuständig ist die Landesbeauftragte für Datenschutz
                  und Informationsfreiheit Nordrhein-Westfalen (LDI NRW), Kavalleriestraße 2–4,
                  40213 Düsseldorf,{" "}
                  <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener noreferrer" className={LINK} data-testid="datenschutz-ldi-link">
                    www.ldi.nrw.de
                  </a>
                  .
                </p>
              </div>

              <div>
                <h2 className={H2}>13. Hinweis zum Glücksspiel</h2>
                <p className={P}>
                  Teilnahme an Sportwetten erst ab 18 Jahren. Glücksspiel kann süchtig machen.
                  Kostenlose und vertrauliche Beratung: BZgA-Telefonberatung „Check dein Spiel“ unter{" "}
                  <a href="tel:08001372700" className={LINK} data-testid="datenschutz-helpline">
                    0800 1372700
                  </a>{" "}
                  sowie{" "}
                  <a href="https://www.check-dein-spiel.de" target="_blank" rel="noopener noreferrer" className={LINK} data-testid="datenschutz-cds-link">
                    check-dein-spiel.de
                  </a>
                  .
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
